"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPC437 = toPC437;
exports.commandCombiner = commandCombiner;
/**
 * Converts any single character to a single byte representation of the
 * character in the PC-437 (IBM PC) code page.
 * @param {String} character
 * @return {number}
 */
function toPC437(character) {
  return character.charCodeAt(0) & 0xff;
}

/**
 * Ingests an array of Array Buffers, returns the result of collapsing them
 * into a single ArrayBuffer
 * @param {Array<ArrayBuffer>} commandList
 * @return {ArrayBuffer}
 */
function commandCombiner(commandList) {
  var totalBytes = commandList.reduce(function (length, buffer) {
    return length + buffer.byteLength;
  }, 0);

  var renderResultBuffer = new ArrayBuffer(totalBytes);
  var resultDVUint8 = new Uint8ClampedArray(renderResultBuffer);

  var i = 0;
  commandList.forEach(function (commandBuffer) {
    resultDVUint8.set(new Uint8Array(commandBuffer), i);
    i += commandBuffer.byteLength;
  });

  return renderResultBuffer;
}